import { createSlice } from "@reduxjs/toolkit";
import { fetchCustomers } from "../thunks/getCustomerThunk";
import { fetchCustomerById } from "../thunks/getCustomerByIdThunk";

const customersSlice = createSlice({
  name: "customers",
  initialState: {
    customers: [],
    total_count: 0,
    filtered_count: 0,
    customer_names: [],
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'error'
    error: null,
    customer: {},
  },
  reducers: {
    resetCustomersState(state) {
      state.error = null;
      state.status = "idle";
      state.customers = [];
      state.customer = {};
    },
    resetCustomersError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.customers = action.payload.customers;
        state.total_count = action.payload.total_count;
        state.filtered_count = action.payload.filtered_count;
        state.customer_names = action.payload.customer_names;
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error.message;
        state.customers = [];
        state.customer_names = [];
        state.total_count = 0;
        state.filtered_count = 0;
        state.customer = {};
      })
      .addCase(fetchCustomerById.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCustomerById.fulfilled, (state, action) => {
        state.customer = action.payload; // Store the fetched customer
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(fetchCustomerById.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error.message;
      });
  },
});

export const { resetCustomersState, resetCustomersError } =
  customersSlice.actions;
export default customersSlice.reducer;
